import {ISearchState} from '@app/shared/models/search-state.model';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {EState} from 'src/app/state/reducers';

export const selectSearchState = createFeatureSelector<ISearchState>(EState.Search);
export const selectSearchStatus = createSelector(selectSearchState, (searchState: ISearchState) => searchState.status);
export const selectSearchResponse = createSelector(
  selectSearchState,
  (searchState: ISearchState) => searchState.successResponse
);
export const selectSearchError = createSelector(
  selectSearchState,
  (searchState: ISearchState) => searchState.errorMessage
);
